module.exports = __webpack_public_path__ + "img/symbol_3.34459610.png";